import './App.css';
import { Route, Routes } from 'react-router-dom';
import Header from './mainComponents/header';
import Footer from './mainComponents/footer';
import Home from './mainPages/home';
import About from './mainPages/about';
import TaxServices from './mainPages/taxServices';
import AccountingServices from './mainPages/accountingServices';
import ContactUs from './mainPages/contactUs';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/tax-services" element={<TaxServices />} />
        <Route path="/accounting-services" element={<AccountingServices />} />
        <Route path="/contact" element={<ContactUs />} />
        <Route path="*" element={<Home />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
